import { Component, ChangeDetectorRef, NgZone, OnDestroy, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { Camera } from '../../models/camera';
import { CameraService } from '../../services/camera.service';
import { CameraCardComponent } from './camera-card.component';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [NgFor, NgIf, CameraCardComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})
export class SettingsComponent implements OnInit, OnDestroy {
  cameras: Camera[] = [];
  isLoading = true;
  errorMessage = '';

  private readonly deviceChangeHandler = () => {
    this.zone.run(() => {
      void this.loadCameras();
    });
  };

  constructor(
    private cameraService: CameraService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    navigator.mediaDevices?.addEventListener('devicechange', this.deviceChangeHandler);
    await this.loadCameras();
  }

  ngOnDestroy() {
    navigator.mediaDevices?.removeEventListener('devicechange', this.deviceChangeHandler);
  }

  async refreshCameras() {
    await this.loadCameras(true);
  }

  trackByDeviceId(_index: number, camera: Camera): string {
    return camera.value;
  }

  private async loadCameras(forceReprobe = false) {
    this.isLoading = true;
    this.errorMessage = '';
    const hadOpenPreviews = this.cameras.length > 0;
    this.cameras = [];
    this.cdr.detectChanges();

    if (hadOpenPreviews) {
      await new Promise(resolve => setTimeout(resolve, 250));
    }

    try {
      this.cameras = await this.cameraService.getAvailableCameras(new Set(), { forceReprobe });
      if (this.cameras.length === 0) {
        this.errorMessage = 'No cameras found. Allow camera access and make sure your USB cameras are connected.';
      }
    } catch (error) {
      console.error('Error loading cameras:', error);
      this.errorMessage = 'Unable to look up cameras. Check browser camera permissions and try again.';
      this.cameras = [];
    } finally {
      this.isLoading = false;
    }
  }
}
